import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthBackLink = ({ label = 'Back to login' }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/auth/login')}
      className="text-center text-sm font-medium text-primary hover:underline">
      {label}
    </button>
  );
};

export default AuthBackLink;
